<template>
   <div class="skeleton">
      <tisc-section v-if="type == 'section'" >
         <template #heading>
            <span class="section__heading-line shine"></span>
         </template>
         <template #body>
            <span class="section-line shine"></span>
            <span class="section-line shine"></span>
            <span class="section-line shine"></span>
            <span class="section-line shine"></span>
            <span class="section-line shine"></span>
            <span class="section-line shine"></span>
            <span class="section-line shine"></span>
            <span class="section-line shine"></span>
         </template>
      </tisc-section>
      
      <div v-else-if="type == 'profile'" class="profile-container">
         <div class="box shine"></div>

         <div class="lines">
            <span class="line shine"></span>
            <span class="line shine"></span>
            <span class="line shine"></span>
         </div>
      </div>

      <div v-else-if="type == 'profile-inline'" class="profile-container--inline">
         <div class="box shine"></div>

         <div class="lines">
            <span class="line shine"></span>
            <span class="line shine"></span>
            <span class="line shine"></span>
         </div>
      </div>

      <div v-else v-for="item in items" :key="item.id" class="skeleton__container">
         <span class="search-line shine"></span>
         <span class="search-line shine"></span>
         <span class="search-line shine"></span>
      </div>

   </div>
</template>

<script>
import tiscSection from "../Elements/tiscSection.vue"
export default {
	components: { tiscSection },
   props: {
      type: { type: String, default: 'search' },
      items: { type: Number, default: 5 },
   }
}
</script>

<style lang="scss" scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Vana/skeleton.scss';
</style>